module.exports = __webpack_public_path__ + "img/steam.0fe1d615.jpg";